const createNamedActions = (namespace) => {
  const namespaceUpper = namespace.toUpperCase()
  const actionNames = {
    INSET_INIT: `${namespaceUpper}:INSET_INIT`,
    INSET_LEAVE: `${namespaceUpper}:INSET_LEAVE`,
    INSET_INFINITE_LOAD: `${namespaceUpper}:INSET_INFINITE_LOAD`,
    INSET_TAB_ROUTE_CHANGE: `${namespaceUpper}:INSET_TAB_ROUTE_CHANGE`,
    INSET_AUDIENCE_FETCH_SUCCESS: `${namespaceUpper}:INSET_AUDIENCE_FETCH_SUCCESS`,
    INSET_AUDIENCE_FETCH_FAILURE: `${namespaceUpper}:INSET_AUDIENCE_FETCH_FAILURE`,
    INSET_INFINITE_LOAD_SUCCESS: `${namespaceUpper}:INSET_INFINITE_LOAD_SUCCESS`,
    INSET_INFINITE_LOAD_ERROR: `${namespaceUpper}:INSET_INFINITE_LOAD_ERROR`,
    INSET_REALTIME_DATA_UPDATE: `${namespaceUpper}:INSET_REALTIME_DATA_UPDATE`,
    INSET_ORDER_CHANGE: `${namespaceUpper}:INSET_ORDER_CHANGE`,
    INSET_PROFILES_REFETCH_SUCCESS: `${namespaceUpper}:PROFILES_REFETCH_SUCCESS`,
    INSET_REMOVE_ATTENDEE: `${namespaceUpper}:INSET_REMOVE_ATTENDEE`,
  }

  const insetInit = (tab, objectId) => {
    return {
      type: actionNames.INSET_INIT,
      tab,
      objectId,
    }
  }

  const insetLeave = () => {
    return {
      type: actionNames.INSET_LEAVE,
    }
  }

  const tabRouteChange = (tab, objectId) => {
    return {
      type: actionNames.INSET_TAB_ROUTE_CHANGE,
      tab,
      objectId,
    }
  }

  const onOrderChange = (orderBy, order) => {
    return {
      type: actionNames.INSET_ORDER_CHANGE,
      orderBy,
      order,
    }
  }

  const onInfiniteLoad = (tab, objectId) => {
    return {
      type: actionNames.INSET_INFINITE_LOAD,
      tab,
      objectId,
    }
  }

  const removeAttendee = (uuid) => {
    return {
      type: actionNames.INSET_REMOVE_ATTENDEE,
      uuid,
    }
  }

  return {
    actionNames,
    insetInit,
    insetLeave,
    tabRouteChange,
    onInfiniteLoad,
    onOrderChange,
    removeAttendee,
  }
}

export default createNamedActions
